var width;

module.exports = function() {
	if(width !== undefined) {
		return width;
	}

	var outer = document.createElement("div");

	outer.style.visibility = "hidden";
	outer.style.width = "100px";
	outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

	document.body.appendChild(outer);

	var widthNoScroll = outer.offsetWidth;
	// force scrollbars
	outer.style.overflow = "scroll";

	// add innerdiv
	var inner = document.createElement("div");
	inner.style.width = "100%";
	outer.appendChild(inner);

	var widthWithScroll = inner.offsetWidth;

	// remove divs
	outer.parentNode.removeChild(outer);

	width = widthNoScroll - widthWithScroll;

	return width;
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/getScrollbarWidth.js
 **/